import { industriesActions } from '../actions';

// listening to an action belonging to another reducer seems to
// give them both undefined state
export default function industries ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case industriesActions.SET_PROFILE_INDUSTRIES: return generalIndustriesReducer( newState, action );
        // case industryListActions.SET_INDUSTRIES: return generalIndustriesReducer( newState, action );
        case industriesActions.GENERAL_INDUSTRIES_SUCCESS: return generalIndustriesReducer( newState, action );
        default: return newState;
    }
}

function generalIndustriesReducer ( newState, action ) {
    delete action.type;
    return  Object.assign( newState, { ...action } );
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/industries.js